import { ComponentRoute } from '@/classes'

const AuthRoutes = {
  ForgotPasswordView: new ComponentRoute('/forgotpassword', 'ForgotPasswordView'),
  ForgotPasswordCsrView: new ComponentRoute('/forgotpasswordcsr', 'ForgotPasswordCsrView'),
  ResetPasswordView: new ComponentRoute('/forgotpasswordreset', 'ResetPasswordView'),
  ForgotPasswordLogListView: new ComponentRoute('/forgotpasswordlog', 'ForgotPasswordLogView')
}

export default AuthRoutes